/*
 * @创建文件时间: 2019-11-22 11:58:54
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-22 20:58:56
 * @联系Qq:1360484677
 * @文件介绍: 养护材料
 */
export default [{
    path: 'bdMaintainMaterialTable',
    name: 'bdMaintainMaterialTable',
    meta: {
        title: '基本材料管理',
        auth: true
    },
    component: () =>
        import ('@/views/basic/storage/bdMaintainMaterialTable')
}, {
    path: 'bdMaterialEnterStockInTable',
    name: 'bdMaterialEnterStockInTable',
    meta: {
        title: '材料入库管理',
        auth: true
    },
    component: () =>
        import ('@/views/basic/storage/bdMaterialEnterStockInTable')
}, {
    path: 'bdMaterialEnterStockPutTable',
    name: 'bdMaterialEnterStockPutTable',
    meta: {
        title: '材料出库管理',
        auth: true
    },
    component: () =>
        import ('@/views/basic/storage/bdMaterialEnterStockPutTable')
}, {
    path: 'bdMaterialInventoryStatistics',
    name: 'bdMaterialInventoryStatistics',
    meta: {
        title: '材料库存统计',
        auth: true
    },
    component: () =>
        import ('@/views/basic/storage/bdMaterialInventoryStatistics')
}, ]